import React from 'react';

interface Props {
  open: boolean;
  title?: string;
  message: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * 轻量确认弹窗（替代原生 window.confirm，避免浏览器显示来源地址）。
 * 遮罩点击或取消关闭；确认时可显示 busy 态。
 */
export const ConfirmDialog: React.FC<Props> = ({
  open,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  busy = false,
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" onMouseDown={busy ? undefined : onCancel}>
      <div
        className="bg-white rounded-2xl shadow-2xl w-[min(400px,92vw)] p-6"
        onMouseDown={(e) => e.stopPropagation()}
      >
        {title && <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>}
        <div className="text-sm text-gray-600 leading-relaxed">{message}</div>
        <div className="mt-6 flex justify-end gap-2">
          <button
            className="btn text-sm py-1.5 px-4 border border-gray-200 text-gray-600 hover:bg-gray-50 disabled:opacity-50"
            onClick={onCancel}
            disabled={busy}
          >
            {cancelText}
          </button>
          <button
            className="btn btn-primary text-sm py-1.5 px-4 disabled:opacity-60"
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? 'Processing…' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};
